import React from 'react'
import PropTypes from 'prop-types'
import SeasonsContainer from './SeasonsContainer'

const Seasons = ({ match }) => <SeasonsContainer match={match} />

Seasons.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default Seasons
